import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "elog-header" }
const _hoisted_2 = { class: "header-inner" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("nav", { class: "nav-center" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "nav-right" }, null, -1)
const _hoisted_6 = { class: "elog-main" }
const _hoisted_7 = { class: "login-card" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Entrar", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Acesse sua conta", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Email", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "mt-3" }, "Senha", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Lembre-me ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Entrar ")
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-card" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Plataforma logística em nuvem"),
    /*#__PURE__*/_createElementVNode("p", null, " Gerencie pedidos, entregas e operações logísticas em ambientes isolados, com alta disponibilidade e escala sob demanda. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "info-card green" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Operações críticas sem interrupções"),
    /*#__PURE__*/_createElementVNode("p", null, " Monitoramento em tempo real, roteirização inteligente e controle operacional para frotas e centros de distribuição. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_argon_input = _resolveComponent("argon-input")!
  const _component_argon_switch = _resolveComponent("argon-switch")!
  const _component_argon_button = _resolveComponent("argon-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$app_name), 1),
        _hoisted_4,
        _hoisted_5
      ])
    ]),
    _createElementVNode("main", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _createVNode(_component_argon_input, {
          type: "email",
          size: "lg",
          placeholder: "email@empresa.com",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.username = $event.target.value))
        }),
        _hoisted_11,
        _createVNode(_component_argon_input, {
          type: "password",
          size: "lg",
          placeholder: "••••••••",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event.target.value))
        }),
        _createVNode(_component_argon_switch, {
          class: "mt-3",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save = $event.target.checked))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_argon_button, {
          class: "mt-4",
          color: "primary",
          fullWidth: "",
          size: "lg",
          onClick: _ctx.doLogin
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.error.show)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.error.message), 1))
          : _createCommentVNode("", true),
        _hoisted_15
      ]),
      _hoisted_16
    ])
  ], 64))
}